import { gql } from '@apollo/client';

export const DOCUMENT_TEMPLATE_DELETED = gql`
  subscription documentTemplateDeleted {
    documentTemplateDeleted {
      documentTemplateId
    }
  }
`;
